<template>
  <w-settings-detail :title="title" :menu="menu" :default-active-menu="defaultMenu" @change="onChangeMenu">
    <component slot="activeView" :is="activeMenu"></component>
  </w-settings-detail>
</template>

<script>
import WSettingsDetail from '@/components/template/SettingsDetail';
import WServerImageSetting from './ServerImageSetting';
import WServerHardwareSetting from './ServerHardwareSetting';

const defaultMenu = 'WServerImageSetting';
export default {
  name: 'WVirtualService',
  components: {
    WSettingsDetail,
    WServerImageSetting,
    WServerHardwareSetting,
  },
  props: {
    title: String,
  },
  data() {
    return {
      defaultMenu,
      activeMenu: defaultMenu,
      menu: [
        {
          id: 'WServerImageSetting',
          name: '서버 이미지 설정',
          active: false,
        },
        {
          id: 'WServerHardwareSetting',
          name: '서버 H/W 사양',
          active: false,
        },
      ],
    };
  },
  methods: {
    onChangeMenu(menu) {
      this.activeMenu = menu;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/VirtualService/index.vue